// Gutenberg block: labify/qa (frontend accordion).
(() => {
  const findAnswer = (btn) => {
    // Prefer strict structure (button -> next sibling answer)…
    const sibling = btn.nextElementSibling;
    if (sibling && sibling.classList && sibling.classList.contains("c-qa__answer")) {
      return sibling;
    }

    // …but be resilient to markup variations (wrappers, legacy blocks, etc.).
    const item = btn.closest(".c-qa__item, .the__qa__e");
    if (!item) return null;
    return item.querySelector(".c-qa__answer, .the__qa__answer");
  };

  const setAnswerOpen = (answer) => {
    answer.classList.add("is-open");
    // Animate: set max-height to content height, then release to 'none'
    answer.style.maxHeight = `${answer.scrollHeight}px`;
    const onEnd = (e) => {
      if (e.propertyName !== "max-height") return;
      answer.style.maxHeight = "none";
      answer.removeEventListener("transitionend", onEnd);
    };
    answer.addEventListener("transitionend", onEnd);
  };

  const setAnswerClosed = (answer) => {
    // If it was released to 'none', lock current height first.
    const current = answer.scrollHeight;
    answer.style.maxHeight = `${current}px`;
    // Next frame: animate to zero.
    requestAnimationFrame(() => {
      answer.classList.remove("is-open");
      answer.style.maxHeight = "0px";
    });
  };

  const toggle = (btn) => {
    const answer = findAnswer(btn);
    if (!answer) return;

    const expanded = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", expanded ? "false" : "true");
    btn.classList.toggle("is-active", !expanded);

    // Ensure answer participates in layout during open animation.
    if ("hidden" in answer && !expanded) {
      answer.hidden = false;
    }

    if (expanded) {
      setAnswerClosed(answer);
      const onEnd = (e) => {
        if (e.propertyName !== "max-height") return;
        if ("hidden" in answer) answer.hidden = true;
        answer.removeEventListener("transitionend", onEnd);
      };
      answer.addEventListener("transitionend", onEnd);
    } else {
      setAnswerOpen(answer);
    }
  };

  const init = () => {
    if (document.documentElement.dataset.qaGlobalInit === "1") return;
    document.documentElement.dataset.qaGlobalInit = "1";

    // Normalize initial state for smooth animation and no "empty padding" on closed items.
    document
      .querySelectorAll(".wp-block-labify-qa.c-qa .c-qa__item")
      .forEach((item) => {
        const btn = item.querySelector(".c-qa__question");
        const answer = item.querySelector(".c-qa__answer");
        if (!btn || !answer) return;

        const isOpen = btn.getAttribute("aria-expanded") === "true";
        btn.classList.toggle("is-active", isOpen);
        answer.classList.toggle("is-open", isOpen);

        if ("hidden" in answer) {
          answer.hidden = !isOpen;
        }

        answer.style.maxHeight = isOpen ? "none" : "0px";
      });

    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".c-qa__question, .the__qa__question");
      if (!btn) return;

      const root = btn.closest(".wp-block-labify-qa.c-qa, .the__qa");
      if (!root) return;

      // If it's a real <button>, avoid any default behaviour.
      if (btn.tagName === "BUTTON") {
        e.preventDefault();
      }

      toggle(btn);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();

